import CategoryNavComponent from '../components/CategoryNav';
import { connect } from 'react-redux';

const CategoryNav = connect(state => state)(CategoryNavComponent);

export default CategoryNav;
